export default "__VITE_ASSET__BubrZv9Z__"